import { useEffect, useState } from 'react';
import { Checkbox, Empty, Modal, Space, Spin, Tag, Typography } from 'antd';
import { useOrderTags } from '@/api/orders/order-tags';

interface BulkOrderTagModalProps {
  open: boolean;
  orderCount: number;
  submitting: boolean;
  onSubmit: (tagIds: string[]) => void;
  onClose: () => void;
}

/** TCR-2264 — gán THÊM thẻ cho nhiều đơn; thẻ sẵn có trên từng đơn giữ nguyên. Quản lý danh mục thẻ vẫn ở `OrderTagModal`. */
export function BulkOrderTagModal({ open, orderCount, submitting, onSubmit, onClose }: BulkOrderTagModalProps) {
  const { data: tags = [], isLoading } = useOrderTags();
  const [selected, setSelected] = useState<string[]>([]);
  useEffect(() => { if (!open) setSelected([]); }, [open]);

  return (
    <Modal
      open={open}
      title={`Gán thẻ cho ${orderCount} đơn`}
      okText="Gán thẻ"
      cancelText="Thoát"
      okButtonProps={{ disabled: selected.length === 0, loading: submitting }}
      onOk={() => onSubmit(selected)}
      onCancel={onClose}
      destroyOnHidden
    >
      <Typography.Paragraph type="secondary">Thẻ được thêm vào các đơn đã chọn; thẻ sẵn có trên đơn giữ nguyên.</Typography.Paragraph>
      {isLoading ? <Spin /> : tags.length === 0 ? <Empty description="Chưa có thẻ đơn hàng" /> : (
        <Checkbox.Group value={selected} onChange={(values) => setSelected(values as string[])}>
          <Space direction="vertical">
            {tags.map((tag) => (
              <Checkbox key={tag._id} value={tag._id} aria-label={tag.name}>
                <Tag color={tag.color}>{tag.name}</Tag>
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      )}
    </Modal>
  );
}
